import { MutableRefObject, useRef, useState } from 'react';

export function useStateWithRef<T>(initial: T): [T, (v: T) => void, MutableRefObject<T | undefined>] {
  const [state, setStateInternal] = useState<T>(initial);
  const ref = useRef<T>(undefined);
  ref.current = state;
  const setState = (v: T) => {
    ref.current = v;
    setStateInternal(v);
  };
  return [state, setState, ref];
}
